/**
 * Nhãn phiên bản (§9.10).
 *
 * `NHAN_PHIEN_BAN` là nhãn hiển thị, **cố ý không có** mã commit để nó không
 * trông như đổi sau mỗi lần triển khai. Mã commit chỉ nằm trong tooltip.
 *
 * Hiện ở đáy thanh điều hướng **và** ở trang đăng nhập — vì lúc cần biết phiên
 * bản nhất chính là lúc không đăng nhập được.
 */
export const NHAN_PHIEN_BAN = "v4.01";

const GIT_SHA = import.meta.env["VITE_GIT_SHA"] as string | undefined;

export const NHAN_CHI_TIET = GIT_SHA
  ? `${NHAN_PHIEN_BAN} · ${GIT_SHA.slice(0, 7)}`
  : NHAN_PHIEN_BAN;
